import { useRef, useState } from 'react';
import type React from 'react';
import styles from './fq.module.css'
import LogoContainer from './logoContainer'
import ContactIcon from '../components/contactIcon';
import Accordion from '../components/accordion';
import { useWindowSize } from '../hooks/useWindowSize';
import useFq, { IKey } from '../hooks/useFq';

const ContactUs = ({ condition }: any) => {
  if (!condition) {
    return null
  }
  return (
    <div className={styles.contactUsContainer}>
      <ContactIcon className={styles.contactIcon} />
      <div className={styles.contactUsText}>未成年人消费/发票处理电话:</div>
      <div className={styles.contactUsPhone}>400-6501866</div>
      <div className={styles.contactUsTime}>(每天9:00-18:00)</div>
    </div>
  )
}

const tabs: IKey[] = ['游戏产品防沉迷', '未成年人消费', '未成年人退款申请', '未成年人苹果账号充值', '联系客服']

const PCView = () => {
  const { answers, changeAnswer } = useFq(tabs[0])
  const [active, setActive] = useState(0)

  const changeTab = (index: number) => {
    setActive(index)
    changeAnswer(tabs[index])
  }
  return (
    <>
      <div className={styles.tabs}>
        {
          tabs.map((tab, index) => (
            // @ts-ignore
            <div key={index} className={styles.tab} active={String(active === index)} onClick={() => changeTab(index)}>
              {tab}
            </div>
          ))
        }
      </div>
      <div className={styles.tabPane}>
        <Accordion panels={answers} key={answers} />
      </div>
    </>
  )
}

const MobileView = ({ parentRef }: any) => {
  const { allFq } = useFq()
  const [answer, setAnswer] = useState<string[]>([])
  const handleDetail = (answer: string[]) => {
    parentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setAnswer(answer)
  }

  return (
    <div className={styles.listContainer}>
      {
        answer.length ?
          (<div className={styles.viewDetail}>
            <div className={styles.viewDetailHead}>
              <div className={styles.viewDetailHeadReturn} onClick={() => setAnswer([])}></div>
              <div className={styles.viewDetailHeadTitle}>问题详情</div>
            </div>
            <div className={styles.viewDetailTitle}>{answer[0]}</div>
            <div className={styles.viewDetailContent} dangerouslySetInnerHTML={{ __html: answer[1] }}></div>
          </div>) :

          tabs.map((tab, index) => (
            <div key={index} className={styles.listItem}>
              <div className={styles.listItemLeft}>{tab}</div>
              <div className={styles.listItemRight}>{
                allFq[tab].map((answer, answerIndex) => (
                  <div
                    className={styles.listItemAnswer}
                    key={answerIndex}
                    onClick={() => handleDetail(answer)}
                  >
                    <span>{answerIndex + 1}、</span>
                    {answer[0]}
                  </div>
                ))
              }</div>
            </div>
          ))
      }
    </div>
  )
}

export default () => {
  const { width } = useWindowSize()
  const sceneRef = useRef() as React.MutableRefObject<HTMLDivElement>

  return (
    <div className={styles.scene1} ref={sceneRef}>
      <LogoContainer />
      <ContactUs condition={width > 1200} />
      <div className={styles.fqContainer}>
        {
          width > 1200 ? <PCView /> : <MobileView parentRef={sceneRef} />
        }
      </div>
      <div className={styles.fqFooter}>
        <div className={styles.footerCompanyLogo}></div>
        <div className={styles.footerCompanyTitle}>北京豪腾创想科技有限公司</div>
        <div className={styles.footerCompanyTitle}>京ICP备2021034633号</div>
        <ContactUs condition={width <= 1200} />
        <div className={styles.footerGameTip}>
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。
        </div>
        <div className={styles.footerGameTip}>
          适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  )
}